import Constants from './Constants.json';

export const API_ENDPOINT = Constants.API_ENDPOINT;
export const IdentityApi = Constants.IdentityApi;
export const OnboardingAPI = Constants.OnboardingAPI;
export const BaseApi = Constants.BaseApi;
export const DocumentServiceApi = Constants.DocumentServiceApi;
export const V2PRMURL = Constants.V2PRMURL;
export const KYCRequestURL = Constants.KYCRequestURL;
export const DownloadFileURL = Constants.DownloadFileURL;
export const IFSCURL=Constants.IFSCUrl;

export const LOGIN_API = `${IdentityApi}api/Account/Login`;
export const AGREEMENT_API = `${OnboardingAPI}api/Customer/UpdateIsAgreementReceived`;
export const MAIL_SENT_API = `${OnboardingAPI}api/Customer/GetCustomerListMailSent`;
export const EXPORT_DATA_API = `${OnboardingAPI}api/Customer/GenerateExcel`;
export const CREATE_V2PRM_API = `${OnboardingAPI}api/Customer/CreateV2PRM`;
export const DOWNLOAD_REQUEST_API = `${DownloadFileURL}api/Document/DownloadFileFromBlob`;
export const REINITIATE_KYC_REQUEST = `${KYCRequestURL}v4/api/v4.0/kyc/ReinitiateKycRequest`;

export const REJECTION_HISTORY_API = `${OnboardingAPI}api/Customer/GetRejectionHistoryList`;
export const PENDING_API = `${OnboardingAPI}api/Customer/GetCustomerListPendingApproval`;
export const ACCEPTED_API = `${OnboardingAPI}api/Customer/GetCustomerListApproved`;
export const CREATE_STAFF_USER = `${OnboardingAPI}api/Customer/CreateStaffUser`;
export const V2P_RM_API = `${OnboardingAPI}api/Customer/GetV2PRM`;
export const PARTNER_BANK_API = `${BaseApi}api/Customer/GetPartnerBank`;
export const PROGRAM_API = `${BaseApi}api/Customer/GetPrograms`;
export const RESEND_EMAIL_API = `${OnboardingAPI}api/Customer/ResendEmail`;
export const UPDATE_V2P_API = `${OnboardingAPI}api/Customer/UpdateV2PRM`;
export const UPDATE_HDFC_API = `${OnboardingAPI}api/Customer/UpdateHDFCRM`;
export const UPDATE_PHONE_EMAIL_API = `${OnboardingAPI}api/Customer/UpdatePhoneEmail`;
export const ONBOARD_NEW_CUSTOMER_API = `${OnboardingAPI}api/Customer/CreateCustomer`;
export const DETAILS_API = `${OnboardingAPI}api/Customer/GetCustomerDetailById`;
export const PHONE_VALIDATE_API = `${OnboardingAPI}api/Login/VerifyPhone`;
export const BUSINESS_TYPE_API = `${BaseApi}api/Customer/BusinessTypesList`;
export const UPDATE_BUSINESS_TYPE_API = `${OnboardingAPI}api/Customer/UpdateBusinessTypeId`;
export const REJECT_CUSTOMER_API = `${OnboardingAPI}api/Customer/RejectCustomer`;
export const APPROVE_CUSTOMER_API = `${OnboardingAPI}api/Customer/ApproveCustomers`;
export const GET_KYC_REQUESTS = `${KYCRequestURL}v4/api/v4.0/kyc/GetKYCRequestList`;
export const CUSTOMER_LOGIN_API = `${OnboardingAPI}api/Login/Login`;
export const CUSTOMER_LOGIN_OTP_API = `${OnboardingAPI}api/Login/VerifyOtp`;
export const VALIDATE_PAN_GSTIN_API = `${OnboardingAPI}api/Customer/ValidateGstinPan`;
export const STEP_TWO_API = `${OnboardingAPI}api/Customer/Step2`;
export const STEP_TWO_WITHOUT_FILE_API = `${OnboardingAPI}api/Customer/Step2WithoutFile`;
export const VERIFY_CIN = `${OnboardingAPI}api/Customer/VerifyCin`;
export const UPDATE_TRUST_NUMBER = `${OnboardingAPI}api/Customer/UpdateTrustNumber`;
export const UPDATE_LAST_STEP = `${OnboardingAPI}api/Customer/UpdateLastStep`;
export const STEP_FIVE_API = `${OnboardingAPI}api/Customer/Step5`;
export const CREATE_PARTNERS = `${OnboardingAPI}api/Customer/CreatePartners`;
export const CREATE_CUSTOMER_USER = `${OnboardingAPI}api/Customer/CreateCustomerUser`;
export const UPDATE_DECLARATION = `${OnboardingAPI}api/Customer/UpdateDeclaration`;
export const REFRESH_TOKEN_STAFF = `${IdentityApi}api/Account/RefreshToken`;
export const RESEND_CODE = `${IdentityApi}api/OTP/GenerateCustomOTP`;
export const CREATE_SINGLE_CUSTOMER_USER = `${OnboardingAPI}api/Customer/CreateSingleCustomerUser`;
export const CUSTOMER_USER_SUBMIT = `${OnboardingAPI}api/Customer/CustomerUserSubmit`;
export const DELETE_CUSTOMER_USER = `${OnboardingAPI}api/Customer/DeleteSingleCustomerUser`;
export const IFSC_API = `${OnboardingAPI}/api/Customer/GetIfscDetails`;
export const UPDATE_BANK_DETAILS_API = `${OnboardingAPI}/api/Customer/AddUpdateCustomerBankDetails`;
export const VERIFY_BANK_DETAILS_API = `${IFSCURL}api/v3.0/BankAccountValidation/BankAccountValidation`;
export const GET_IDENTITY_DETAILS_API = `${OnboardingAPI}api/Customer/GetEntityDetails`;
export const B2B_ONBOARDING_SUBMIT_API = `${OnboardingAPI}api/Customer/B2BOnBoardingSubmit`;
export const GENERATE_REPORT_API = `${KYCRequestURL}v4/api/v4.0/rubix/CreateReportRequest`;


// Add more endpoints as needed
